import { sanitizeHtml } from "@/utils/sanitizeHtml";

/**
 * 左侧筛选框标题
 * @param title
 * @returns
 */
const FilterTitle = ({
  title,
  type = "text",
  badge,
}: {
  title: string;
  type?: string;
  badge?: number;
}) => {
  return (
    <div className="mb-8 flex flex-col self-baseline text-base font-semibold">
      <div className="flex items-center gap-2">
        {type === "text" ? (
          <>{title}</>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(title) }}></div>
        )}
        {badge != null && badge > 0 && (
          <span className="text-xs font-semibold text-red-500">{badge}</span>
        )}
      </div>

      <div
        className="mt-[3px] h-[2px] w-full bg-primary"
        style={{ transform: "skewX(-45deg)" }}
      ></div>
    </div>
  );
};

export default FilterTitle;
